module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "reservation-modal payment dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('view-header', {
    attrs: {
      "title": "Payment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "p-4 col-5 sidebar"
  }, [_c('div', {
    staticClass: "summary pb-5"
  }, [_c('summary-header', {
    attrs: {
      "tag": false
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.paxTotal) + " PAX, " + _vm._s(_vm.extrasQuantityTotal) + " extras\n                ")])], 1), _vm._v(" "), _c('discount', {
    attrs: {
      "reservation": _vm.getClonedReservation,
      "product": _vm.product
    },
    on: {
      "updateDiscountType": _vm.updateDiscountType,
      "updateDiscountValue": _vm.updateDiscountValue
    }
  }), _vm._v(" "), _c('summary-totals', {
    attrs: {
      "reservation": _vm.getClonedReservation,
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-7 p-4 main"
  }, [_c('h5', {
    staticClass: "bold mb-2"
  }, [_vm._v("Select payment details")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small"
  }, [_vm._v("Set amount and payment method, you can also split the bill")]), _vm._v(" "), _c('payment-methods', {
    attrs: {
      "reservation": _vm.getClonedReservation,
      "product": _vm.product
    },
    on: {
      "validatePayments": _vm.validatePayments,
      "updatePayments": _vm.updatePayments
    }
  }), _vm._v(" "), _c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.billing.description),
      expression: "form.billing.description"
    }],
    staticClass: "full",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.form.billing.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.billing, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('payment-details', {
    attrs: {
      "reservation": _vm.getClonedReservation,
      "product": _vm.product
    },
    on: {
      "updateDetails": _vm.updateDetails
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wide",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wide",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-23391e80", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23391e80"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayment.vue
// module id = 1227
// module chunks = 0